import { useContext, useEffect, useState } from 'react'
import { Notification, notificationUpdate } from '../../contexts/notification/notificationAction'
import styleNotification from './Notification.module.scss'
import { NotificationContext } from '../../contexts'

interface INotificationViewProps {
  notifications: Notification[]
  myClassNames: (notification: Notification) => string
}

export type NotificationViewProps = INotificationViewProps

export const useNotification = (): NotificationViewProps => {
  const { notificationState, notificationDispatch } = useContext(NotificationContext)
  const [time, setTime] = useState<string | number | NodeJS.Timeout>(null)

  useEffect(
    () => {
      const notifications = notificationState.notifications
      if (notifications.length > 0) {
        setTime(
          setInterval((): void => {
            const time: number = parseInt((new Date().getTime() / 1000).toString())
            // console.log(notifications, time);
            notifications.forEach((notification, index) => {
              const timeout = time - notification.timeout
              if (timeout > notification.timeLife) {
                notifications.splice(index, 1)
                notificationDispatch(notificationUpdate(notifications))
              }
            })
          }, 1000)
        )
      }

      return (): void => { clearInterval(time) }
    },
    [notificationState]
  )

  const myClassNames = (notification: Notification): string => {
    return (
      notification.colorMessage === 'blue'
        ? styleNotification._short_blue
        : notification.colorMessage === 'green'
          ? styleNotification._short_green
          : notification.colorMessage === 'red'
            ? styleNotification._short_red
            : notification.colorMessage === 'yellow'
              ? styleNotification._short_yellow
              : ''
    )
  }

  return {
    notifications: notificationState.notifications,
    myClassNames
  }
}
